import { Component, OnInit, Input, Output, EventEmitter, HostListener } from '@angular/core';
import { Observable ,  Subject } from 'rxjs';
import { Store } from '@ngrx/store';
import * as reducers from '../../../reducers';
import { ProductCompare } from '../../../shared/interface/product-compare';
import * as productActions from '../../product.actions';
import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { resizeImg, showImgError, stopBodyScrolling } from '../../../shared/utils/utils';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';


@Component({
	selector: 'compare-overlay',
	templateUrl: './compare-overlay.component.html',
	styleUrls: ['./compare-overlay.component.scss']
})
export class CompareOverlayComponent implements OnInit {
	@Input() screenWidth: string;
	@Input() viewportType: string;
	@Input() productCompare: ProductCompare[];
	showCompareOverlay: boolean = false;
	slideCompareOverlayHighest: boolean = false;
	useNormalZIndex: boolean = false;
	enableCompareBtn: boolean = false;
	enableCompareBtnLater: boolean = false;
	hasTransitionend: boolean = false;
	resizeImg;
	showImgError;
	locale: string;
	stopBodyScrolling;
	@Output() transitionEnd = new EventEmitter();
	destroy$: Subject<boolean> = new Subject<boolean>();

	thumbnailW: number = 160;
	thumbnailH: number = 160;

	winPageYOffset: number;
	maxContainerHeight: number;
	headerHeight: number = 90;
	footerHeight: number = 40;
	extraTitleContainerHeight: number = 0; //96
	compareBtnHeight: number = 38;
	compareContainerStartHeight: number;
	compareContainerEndHeightXL: number;
	compareContainerEndHeightLG: number;
	compareContainerEndHeightMD: number;
	compareContainerEndHeightSM: number;

	constructor(private store: Store<reducers.State>,
		private router: Router,
		private location: Location,
		private route: ActivatedRoute,
		private translate: TranslateService) {
		this.compareContainerStartHeight = this.compareBtnHeight + 2; //2 is the total of top and bottom border width
		this.compareContainerEndHeightXL = this.compareContainerStartHeight + 469 + this.extraTitleContainerHeight;
		this.compareContainerEndHeightLG = this.compareContainerStartHeight + 465 + this.extraTitleContainerHeight;
		this.compareContainerEndHeightMD = this.compareContainerStartHeight + 845; //869
		this.compareContainerEndHeightSM = this.compareContainerStartHeight + 1633;
		this.resizeImg = resizeImg;
		this.showImgError = showImgError;
		this.stopBodyScrolling = stopBodyScrolling;
	}

	ngOnInit() {
		this.route.params.subscribe(params => {
			this.locale = params['locale'];
		});
		window.addEventListener('resize', () => {
			if (this.showCompareOverlay) {
				this.updateMobileHeight();
			}
		});
		window.addEventListener('orientationchange', () => {
			if (this.showCompareOverlay) {
				this.updateMobileHeight();
			}
		});
	}

	ngDoCheck() {
		this.enableCompareBtn = this.enableCompareBtnLater;
	}

	onCompareButtonClick(e): void {
		if (this.showCompareOverlay || this.getTotal() > 0) {
			this.animateOverlay();
			setTimeout(() => {
				if (!this.hasTransitionend) {
					this.onTransitionendForIE({ target: document.getElementById('compareCont') });
				}
			}, 300);
		}
		e.target.blur();
	}

	animateOverlay(): void {
		this.showCompareOverlay = !this.showCompareOverlay;
		if (!this.showCompareOverlay && (this.screenWidth === "SM" || this.screenWidth === "MD")) {
			document.getElementById('compareCont').style.height = "";
			document.getElementById('compareBody').style.height = "";
		}
		if (this.screenWidth === "SM" || this.screenWidth === "MD") {
			// SHOP-347
			if (this.showCompareOverlay) {
				this.winPageYOffset = window.pageYOffset;
			}
			document.body.style.overflow = 'hidden';
			this.stopBodyScrolling(this.showCompareOverlay);
		}
		if (this.showCompareOverlay && (this.screenWidth === "LG" || this.screenWidth === "XL")) {
			document.getElementById('filterCompareCont').style.zIndex = "1995";
			//document.getElementById('compareCont').style.zIndex = "12995";
		}
		this.useNormalZIndex = true;
		this.slideCompareOverlayHighest = this.isContainerTooTall();
		this.transitionEnd.emit({ useNormalZIndex: this.useNormalZIndex });
	}

	isContainerTooTall(): boolean {
		//this.maxContainerHeight = window.innerHeight - this.footerHeight - this.headerHeight - 40;
		this.maxContainerHeight = window.innerHeight - this.headerHeight;
		//this.maxContainerHeight = window.innerHeight;
		if (this.screenWidth === "XL") {
			if (this.compareContainerEndHeightXL > this.maxContainerHeight) {
				return true;
			}
		} else if (this.screenWidth === "LG") {
			if (this.compareContainerEndHeightLG > this.maxContainerHeight) {
				return true;
			}
		} else if (this.screenWidth === "MD") {
			if (this.compareContainerEndHeightMD > this.maxContainerHeight) {
				return true;
			}
		} else {
			if (this.compareContainerEndHeightSM > this.maxContainerHeight) {
				return true;
			}
		}
		return false;
	}

	onTransitionendForIE(e): void {
		this.processTransitionend();
	}

	onTransitionend(e): void {
		this.hasTransitionend = true;
		this.processTransitionend();
	}

	processTransitionend() {
		if (this.showCompareOverlay) {
			this.updateMobileHeight();
			//document.body.style.overflow = 'hidden';
		} else {
			this.useNormalZIndex = false;
			this.transitionEnd.emit({ useNormalZIndex: this.useNormalZIndex });
			//document.body.style.overflow = '';
			document.getElementById('filterCompareCont').style.zIndex = "892";
			//document.getElementById('compareCont').style.zIndex = "auto";
			if (this.screenWidth === "SM" || this.screenWidth === "MD") {
				document.body.style.overflow = '';
				this.winPageYOffset && window.scroll(0, this.winPageYOffset);
			}
		}
	}

	updateMobileHeight() {
		setTimeout(() => {
			if (this.showCompareOverlay) {
				this.maxContainerHeight = window.innerHeight - this.headerHeight;
				if (this.screenWidth === "SM") {
					if (this.isContainerTooTall()) {
						document.getElementById('compareCont').style.height = (this.maxContainerHeight - 0) + "px";
						document.getElementById('compareBody').style.height = (this.maxContainerHeight - this.compareContainerStartHeight - 0) + "px";
					} else {
						document.getElementById('compareCont').style.height = this.compareContainerEndHeightSM + "px";
						document.getElementById('compareBody').style.height = (this.compareContainerEndHeightSM - this.compareContainerStartHeight) + "px";
					}
				} else if (this.screenWidth === "MD") {
					if (this.isContainerTooTall()) {
						document.getElementById('compareCont').style.height = (this.maxContainerHeight + 0) + "px";
						document.getElementById('compareBody').style.height = (this.maxContainerHeight - this.compareContainerStartHeight + 0) + "px";
					} else {
						document.getElementById('compareCont').style.height = this.compareContainerEndHeightMD + "px";
						document.getElementById('compareBody').style.height = (this.compareContainerEndHeightMD - this.compareContainerStartHeight) + "px";
					}
				}
			}
		}, 1);
	}

	removeProduct(compareItem) { 
		setTimeout(() => {
			this.getTotal();
		}, 60);
		//	$('.js-product-item').removeData();
		let compareTranslatedLabel = 'compare';
		this.translate.get('compare').subscribe(r => compareTranslatedLabel = r);
		jQuery("button[id='compare_"+compareItem.productUPC+"']").addClass("compare").removeClass("remove").text(compareTranslatedLabel);
		this.store.dispatch(new productActions.RemoveComparedProduct(compareItem.productUPC));
	}

	getTotal(): number {
		let btn = document.getElementById("cbtn");
		this.enableCompareBtnLater = false;
		let count = 0;
		for (let i = 0; i < 4; i++) {
			if (this.productCompare[i]) {
				count++;
			}
		}
		if (this.showCompareOverlay || count > 0) {
			btn.style.cursor = 'pointer';
		} else {
			btn.style.cursor = 'default';
		}
		if (count > 1) {
			this.enableCompareBtnLater = true;
		}
		return count;
	}

	goToComparePage() {
		if (this.getTotal() > 1) {
			if (this.screenWidth === "SM" || this.screenWidth === "MD") {
				this.stopBodyScrolling(false);
			}
			if (this.showCompareOverlay && (this.screenWidth === "SM" || this.screenWidth === "MD")) {
				document.getElementById('compareCont').style.height = "0px";
				this.showCompareOverlay = false;
			}
			window.scroll(0, 0);
			document.body.style.overflow = '';
			this.router.navigate(['/' + this.locale + '/geforce/store/compare']);
		}
	}

	ngOnDestroy() {
		this.destroy$.next(true);
		this.destroy$.unsubscribe();
	}

	onOverlayBodyClick(e) {
		e.stopPropagation();
	}

	onOverlayClick(e) {
		setTimeout(() => {
			e.stopPropagation();
		}, 10);
	}

	closeOverlay(e, overlayContainer) {
		if ((e.type === 'click' && e.target !== overlayContainer && !overlayContainer.contains(e.target)) || (e.type === 'keyup' && e.keyCode === 27)) {
			this.showCompareOverlay && this.onCompareButtonClick(e);
		}
	}
}
